import {
  VISUAL_MARGIN_DENOMINATOR,
  VISUAL_MARGIN_NUMERATOR,
  type NormalizedVisualScore,
} from '../../types/api/macroCalibration';

const marginNumerator = BigInt(VISUAL_MARGIN_NUMERATOR);
const marginDenominator = BigInt(VISUAL_MARGIN_DENOMINATOR);

/** Accepts a raw difference threshold and runner-up margin by bigint cross-multiplication. */
export class VisualRationalDecision {
  public acceptsScore(score: NormalizedVisualScore, thresholdPercent = 0): boolean {
    if (score.status !== 'scored' || score.forcedMismatch !== undefined
      || !Number.isSafeInteger(score.differenceNumerator) || !Number.isSafeInteger(score.differenceDenominator)
      || score.differenceNumerator > score.differenceDenominator) return false;
    return this.isAccepted(BigInt(score.differenceNumerator), BigInt(score.differenceDenominator), thresholdPercent);
  }

  public isAccepted(numerator: bigint, denominator: bigint, thresholdPercent = 0): boolean {
    if (denominator <= 0n || numerator < 0n || !Number.isInteger(thresholdPercent)
      || thresholdPercent < 0 || thresholdPercent > 100) return false;
    return numerator * 100n <= BigInt(thresholdPercent) * denominator;
  }

  public marginHolds(bestNumerator: bigint, bestDenominator: bigint,
    runnerNumerator: bigint, runnerDenominator: bigint): boolean {
    if (bestDenominator <= 0n || runnerDenominator <= 0n || bestNumerator < 0n || runnerNumerator < 0n) return false;
    const gap = runnerNumerator * bestDenominator - bestNumerator * runnerDenominator;
    return gap * marginDenominator >= marginNumerator * bestDenominator * runnerDenominator;
  }
}
